<template>
  <div class="basic-block block-special-base" :style="styles">
    <div class="title-box">
      <h2>会員特典</h2>
      <img class="title-line" src="/static/img/recommend/lp/touwa/lp_titleline.svg" alt="">
    </div>


    <div class="content-wrap">
      <div class="block-special-base__inner">

        <!-- <img class="special-index" src="/static/img/recommend/lp/touwa/special_index.png" alt=""> -->
        <subsc-description />






        <img class="banner" src="/static/img/recommend/lp/common/uTV/tokuten_img2.webp" alt="">

        <div class="btn-area">
          <span class="button-link" @click="clickedSubsc"><span class="button-face">登録して占う</span></span>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import LpTitle from '@/utvStore/components/recommend/lp/partials/LpTitle'
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
import BlockAboutCounselor3 from './BlockAboutCounselor3'
import LineCampaignMessage from '@/utvStore/components/recommend/lp/partials/LineCampaignMessage'
import SubscDescription from '@/utvStore/components/partials/SubscDescription'

export default {
  name: 'BlockSpecial',
  components: {
    SubscDescription,
    LpTitle,
    LpBaseButton,
    BlockBanner,
    BlockAboutCounselor3,
    LineCampaignMessage
  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    lpId: Number,
    subscUrl: String,
    gaTarget: String,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked () {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-free-shindan-button`,
      })
      location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`)
    },
    clickedSubsc() {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}${this.gaTarget}-subsc-button`,
        'event_label': 'bottom',
      })
      location.href = this.$handoverParams(this.subscUrl)
    },
  },

}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

$uranaitv_black :#32373f;

.block-special-base {
  background: #fff;
  padding: 40px 0 70px;
  h2{
    font-style: normal;
    font-weight: 300;
    font-size: 22px;
    line-height: 30px;
    color: $uranaitv_black;
    margin:0;
    margin-bottom: 16px;
  }
  .title-box {
    text-align: center;
  }
  .title-line{
    margin-bottom: 24px;
  }
  .special-index{
    //width: 335px;
    width: 100%;
    margin:auto;
    margin-bottom:16px;
    display: block;
  }
  .banner{
    max-width:275px;
    width: 100%;
    margin:auto;
    margin-bottom: 24px;
    display: block;
  }


  &__inner {
    padding: 0 20px 20px;
    background: #fff;

  }

  .baseButton {
    width: 80%;
    max-width: 382px;
    margin: auto;
    /deep/ {
      .baseButton__button--primary {
        background: #6799CB;
        .baseButton__button__label {
          color: #6799CB;
          &::after {
            background-color: #6799CB;
          }
        }
      }
    }
  }

}


.btn-area {
  max-width: 315px;
  margin: auto;
}
.button-link {
  min-width: 270px;
  max-width: 400px;
  margin: 0 auto;
  font-weight: bold;
  font-size: 16px;
  color: white;
  min-height: 55px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 100px;
  cursor: pointer;
  position:relative;
  background: $col_def_gradient;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  user-select: none;
  &::before {
    position:absolute;
    top:0;
    left:0;
    z-index:-1;
    box-sizing:border-box;
    border-radius:100px;
    padding:2px;
    width:100%;
    height:100%;
    background:#fff;
    background-clip:content-box;
    content:"";
  }
  .button-face {
    color: $col_temp_key1;
    background: $col_def_gradient;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    /deep/ {
      .notice,
      .face-body{
        display: block;
        width: 100%;
        color: $col_temp_key1;
        //グラデ方向崩れるため個別指定
        background: $col_def_gradient;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .notice {
        font-size: 0.8em;
        line-height: 1;
      }
    }
  }
  &.disable {
    pointer-events: none;
    background: #dcdfe2;
    .button-face {
      color: #dcdfe2;
      background: none;
      -webkit-text-fill-color: initial;
      -webkit-background-clip: border-box;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/blocks/BlockSpecial.vue